/// <reference types="@angular/localize" />

import { isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import * as Sentry from "@sentry/angular";
import { register } from 'swiper/element/bundle';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (!isDevMode()) {
  Sentry.init({
    dsn: "https://2cc10ee0273abed8f34a2c2bf5102ccb@o4509207551410176.ingest.de.sentry.io/4509237140914256",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}

register();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
